module.exports = __webpack_public_path__ + "files/38da64fd1999f89bcfd024a6617fc4a5.png";